/**
 * Public signed link kinds (ADR 0017). The server signs and checks tokens (kernel `signLink` / `verifyLink`, task C3);
 * the web build serves the pages at `<PUBLIC_LINK_BASE_URL><prefix><token>`.
 */
export const LINK_KINDS = {
    prearrival: { prefix: '/p/', module: 'pre-registration', singleUse: false },
    feedback: { prefix: '/f/', module: 'feedback', singleUse: false },
    companion_invite: { prefix: '/c/', module: 'companion', singleUse: true },
    companion_magic: { prefix: '/c/', module: 'companion', singleUse: true },
    host_action: { prefix: '/h/', module: 'notifications', singleUse: false },
    // Phase 3 (ADR 0022). Printed codes get a far-future expiry and are revoked by their row's link_version.
    contactless_site: { prefix: '/k/', module: 'contactless', singleUse: false },
    sign_in_point: { prefix: '/s/', module: 'sign-in-points', singleUse: false },
    // Phase 4 (ADR 0029): GDPR self-service. The request status page (after the code check) and the 7-day export download.
    data_request: { prefix: '/d/', module: 'data-protection', singleUse: false },
    data_export: { prefix: '/x/', module: 'data-protection', singleUse: false },
};
/** Actions a host can take from an email link (kind `host_action`, payload field `a`). */
export const HOST_ACTIONS = ['on_my_way', 'please_wait', 'running_late', 'cancelled'];
//# sourceMappingURL=links.js.map